module.exports = __webpack_public_path__ + "img/fund-banner2.5be87d30.jpg";